import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-multi-date-picker";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import TablePlaceHolder from "../../Helpers/Components/TablePlaceHolder";
import PageChanger from "../../Helpers/Components/Pagination";
import Select from 'react-select'
import Handler from "../../Helpers/Components/Handler";
import Modal from '../../Helpers/Components/Modal'
import { toast } from "react-toastify";

const List = () => {
  const { pageNo } = useParams()
  const navigate = useNavigate()
  const [next, setNext] = useState(false)
  const [loading, setLoading] = useState(false)
  const [custDetails, setCustDetails] = useState([])
  const [checkDate, setCheckDate] = useState()
  const [total, setTotal] = useState(0)
  const calendarRef = useRef();
  const [view, setView] = useState({ open: false })
  const [approval, setApproval] = useState({ open: false, status: false })
  const [filter, setFilter] = useState({
    count: 10,
    sortBy: "createdAt",
    sort: true,
    search: "",
    status: "all"
  })
  const sort = (sortBy, sort) => {
    setPageNo(1)
    setFilter((prev) => ({ ...prev, sortBy: sortBy, sort: sort }))
  }
  const handleOpen = () => {
    if (calendarRef.current) calendarRef.current.openCalendar();
  };
  const setFilteration = (name, value) => {
    setPageNo(1)
    setFilter((prev) => ({ ...prev, [name]: value }))
  }
  const getCustomerDetails = async () => {
    setLoading(true)
    const response = await Handler({
      method: "post", url: `/admin/site/customer/list/${pageNo - 1}?count=${filter?.count || 10}`,
      data: {
        ...(checkDate?.length ? { from: moment(new Date(checkDate[0]))?.format("DD-MM-YYYY"), to: checkDate?.length >= 2 ? moment(new Date(checkDate[1]))?.format("DD-MM-YYYY") : moment(new Date(checkDate[0]))?.format("DD-MM-YYYY") } : {}),
        sort: filter?.sort,
        sortBy: filter?.sortBy,
        ...(filter?.status !== "all" ? { status: filter.status } : {}),
        ...(filter?.search ? { search: filter.search } : {})
      }
    })
    if (response?.success) {
      setCustDetails(response?.data?.list)
      setNext(response?.data?.next)
      setTotal(response?.data?.total)
    } else {
      setCustDetails([])
      setNext(false)
      setTotal(0)
    }
    setLoading(false)
  }
  const approvalDetails = async () => {
    if (!approval?.status && !approval.reason) return toast.error("Reason is required")
    setLoading(true)
    const response = await Handler({ method: 'PATCH', url: `/admin/site/customer/approval/${approval?.customerId}`, data: { status: approval.status, ...(approval?.status ? {} : { reason: approval.reason }) } })
    setLoading(false)
    if (!response.success) return toast.error(response.message)
    setApproval({ open: false })
    getCustomerDetails()
  }
  const setPageNo = (value) => navigate(`/site-customer/${value}`)
  useEffect(() => {
    getCustomerDetails()
  }, [pageNo, filter, checkDate])
  return (
    <React.Fragment>
      <h5 className="text-center text-theme fs-4">SignUp Customer Details</h5>
      <div className="layout-card mt-4">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-4">
            <div>Total Customer: {total}</div>
          </div>
        </div>
        <div className='overflow list-table mt-3'>
          <table className="table-bg table" borderless="true">
            <thead>
              <tr className="border-bottom" >
                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "customerId" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("customerId", false)} >▲</i><i className={filter?.sortBy === "customerId" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("customerId", true)} >▼</i></div> Cust Id</div></th>
                <th> Cust Name</th>
                <th><div className='sort-head'><div className='sort-arrow' ><i className={filter?.sortBy === "createdAt" && filter?.sort === false ? "i-active" : ""} onClick={() => sort("createdAt", false)} >▲</i><i className={filter?.sortBy === "createdAt" && filter?.sort === true ? "i-active" : ""} onClick={() => sort("createdAt", true)} >▼</i></div> <button className='created-at' onClick={() => { handleOpen() }}>Created At <i className="fa-solid fa-caret-down"></i></button> </div></th>
                <th> Phone Number </th>
                <th> Status </th>
                <th> Approved/Rejected By </th>
                <th className="text-center"> Action </th>
              </tr>
            </thead>
            <tbody>
              {!loading ?
                (custDetails && custDetails?.length !== 0 ? custDetails?.map((value, key) => {
                  return (
                    <tr key={key} className={`table-content-row`}>
                      <td>{value?.customerId}</td>
                      <td><div className="text-capitalize">{((value?.firstName || "") + " " + (value?.lastName || ""))}</div></td>
                      <td>{value?.createdAt ? moment(value?.createdAt).format('DD/MM/YYYY') : "-"}</td>
                      <td className="text-capitalize">{value?.phoneNo?.number || ""}</td>
                      <td className={`text-capitalize fw-bold ${value?.approval?.approved === true ? "text-success" : (value?.approval?.approved === false ? "text-danger" : "text-warning")}`}>
                        <div> {value?.approval?.approved === true ? "Approved" : (value?.approval?.approved === false ? "Rejected" : "Pending")}</div>
                      </td>
                      <td>{value?.approvedBy || ""}</td>
                      <td className="text-capitalize">{value?.approval?.approved !== true && value?.approval?.approved !== false ?
                        <div className="d-flex align-items-center gap-1 justify-content-center"> <button className="btn btn-sm btn-success" disabled={loading} onClick={() => setApproval({ open: true, status: true, customerId: value.customerId })}>Approve</button><button className="btn btn-sm btn-danger" onClick={() => setApproval({ open: true, status: false, customerId: value.customerId })} disabled={loading}>Reject</button>
                        </div> :
                        <div className="d-flex align-items-center justify-content-center">{value?.approval?.approved === false ? <button className="btn border-0 p-0" onClick={() => setView({ open: true, ...value })}> <i className="fa-solid fa-eye text-danger"></i> </button> : ""}</div>}</td>
                    </tr>
                  )
                }) :
                  <tr className='text-center' ><td colSpan={7}>No Data Found</td></tr>)
                : <TablePlaceHolder count={7} />
              }
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-end mt-3">
          <span className="me-2 fw-medium"> Page Count:  </span>
          <Select
            className="inside-select"
            isDisabled={loading}
            onChange={(selectedoption) => {
              setFilteration("count", Number(selectedoption?.value))
            }}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                "&:hover": {
                  borderColor: "#f16436"
                }
              }),
              option: (style, state) => ({
                ...style,
                backgroundColor: state.isSelected
                  ? "#f16436"
                  : (state.isFocused || state.isActive)
                    ? "#f164361a"
                    : "white",
                color: state.isSelected ? "white" : "black"
              })
            }}
            value={filter?.count ? { label: filter?.count, value: filter?.count } : { label: 10, value: 10 }}
            options={[
              { label: 10, value: 10 },
              { label: 20, value: 20 },
              { label: 30, value: 30 },
              { label: 40, value: 40 },
              { label: 50, value: 50 },
            ]}
            placeholder="PageNo"
          />
        </div>
        <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue='customer' />
      </div>
      <DatePicker
        ref={calendarRef}
        range
        className='rmdp-mobile'
        inputClass='d-none'
        onChange={(e) => { setPageNo(1); if (!isNaN(new Date(e[0]))) { setCheckDate(e); } }}
        value={checkDate}
        mobileButtons={[
          {
            label: "RESET",
            type: "button",
            className: "rmdp-button rmdp-action-button",
            onClick: () => setCheckDate({}),
          },
        ]}
      />
      <Modal header="Approval" onShow={approval.open} toggle={() => setApproval({ open: false })} overlayToggle={() => setApproval({ open: false })} >
        <div className="modalPhoto">
          <div>Are you sure you want to <span className="fw-bold">{approval?.status ? "Approve" : "Reject"}</span> this customer?</div>
          {approval?.status ? "" : <input autoComplete="off" value={approval?.reason || ""} placeholder="Reason" disabled={loading} className="form-control input-theme text-uppercase mt-3" type="text" onChange={(e) => setApproval((prev) => ({ ...prev, reason: e.target.value }))} />}
        </div>
        <div className="pt-4 pb-2 text-center">
          <button disabled={loading} className={`btn btn-sm ${approval?.status ? "btn-success" : "btn-danger"}`} onClick={approvalDetails}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : (approval?.status ? "Approve" : "Reject")}</button>
        </div>
      </Modal>
      <Modal header="Reason" onShow={view.open} toggle={() => setView({ open: false })} overlayToggle={() => setView({ open: false })} >
        <div className="modalPhoto">
          <div className="text-muted">Reason: {view.errorMsg || ""}</div>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default List;